import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
//import XLSX from 'xlsx'; // Import xlsx library
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData, DespatchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Select from 'react-select';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import ReactPaginate from 'react-paginate';
import CircularProgress from '@mui/material/CircularProgress';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa';
import { Tooltip } from '@mui/material';
import { useParams, useHistory } from 'react-router-dom';
import TablePagination from '@mui/material/TablePagination';
import TableFooter from '@mui/material/TableFooter';
import { FaCar } from 'react-icons/fa'; // Import the car icon

function ForLoadingDespatchReport() {

    const history = useHistory();

    const [data, setData] = useState([]);

    const tableRef = React.createRef();
    const [isFocused, setIsFocused] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();
    const [routeOptions, setRouteOptions] = useState([]);
    const [selectedRoute, setSelectedRoute] = useState(null);
    const formattedDate = new Date().toISOString().split('T')[0];
    const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);
    const [routeId, setrouteId] = useState('');
    const [tripOptions, setTripOptions] = useState([]);
    const [selectedTrip, setSelectedTrip] = useState(null);
    const [route, setRoute] = useState('');
    const [salesman, setSalesman] = useState('');
    const [OdoMeter, setOdometerReading] = useState(''); // for update by closing the trip after  Completed the ordered item delivered

    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 10;

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, userId, token, logout]);

    const openModal = (item) => {
        setSelectedItem(item); // Set selected item before opening modal
        setShowModal(true);
    };

    // Call this function when you want to open the modal with the selected trip


    const [selectedItem, setSelectedItem] = useState(null);
    const [startAutometereReading, setStartAutometereReading] = useState("");


    const hasReadReportPermission = permissions.includes('Read Reports');

    const [TripId, settripId] = useState('');

    useEffect(() => {
        fetchTripTypes();
    }, []);

    const fetchTripTypes = async () => {
        try {
            const response = await fetchData('CustomerOrderedItemAPI', `/${companyId}`, token);

            // Check if response is valid and has data
            if (response.responseCode === '1111' && Array.isArray(response.response_data)) {
                const options = response.response_data.map(trip => ({
                    value: trip.Id,
                    label: trip.Description
                }));
                setTripOptions(options);
            } else {
                console.warn('No trip data found');
            }
        } catch (error) {
            console.error('Error fetching trip types:', error.message);

        }
    };

    const [hasExtraOrders, setHasExtraOrders] = useState(false);
    const [extraOrders, setExtraOrders] = useState([]);
    const [VehicleNo, setVehicleNo] = useState([]);
    const [TripDate, setTripDate] = useState();
    const [DriverName, setDriverName] = useState();

    const handleTripChange = async (selectedOption) => {
        setSelectedTrip(selectedOption);
        settripId(selectedOption.value);

        if (!selectedOption) return; // Early return if no option is selected

        try {
            const response = await fetchData('DespatchReport', `/${companyId}/${selectedOption.value}`, token);
            if (response.responseCode === '1111') {
                const dataArray = response.response_data;

                if (dataArray.length > 0) {
                    setData(dataArray);
                    setCorderdate(dataArray[0].orderDate);
                    setOrdertakenby(dataArray[0].orderTakenby);
                    setRoute(dataArray[0].routeName);
                    setSalesman(dataArray[0].executive);
                    setTripDate(dataArray[0].TripDate);
                    setVehicleNo(dataArray[0].VehicleNo);
                    setDriverName(dataArray[0].DriverName);
                    setrouteId(dataArray[0].routeId);
                    setFilteredData(dataArray.filter(item => item.route === selectedOption.value));
                }
                console.log(response);
            }
        } catch (error) {
            console.error('Error fetching Customer Details:', error);
        }
    };

    //vehicletype

    const [vehicletypeId, setvehicletypeId] = useState('');
    const [vehicletypeOptions, setvehicletypeOptions] = useState([]);
    const [selectedvehicletype, setSelectedvehicletype] = useState(null);


    useEffect(() => {
        const fetchVehicleTypes = async () => {
            try {
                const response = await fetchData('VehicleTypeApi', `/${companyId}`, token);

                if (response.responseCode === '1111') {
                    const dataArray = response.response_data;
                    const options = response.response_data.map(vehtype => ({
                        value: vehtype.id,
                        label: vehtype.name
                    }));
                    setvehicletypeOptions(options);
                }
            } catch (error) {
                console.error('Error fetching vehicle models:', error);
            }
        };

        fetchVehicleTypes();
    }, [companyId, token]);

    //Vehicle
    const [vehicleOptions, setVehicleOptions] = useState([]);
    const [selectedVehicle, setSelectedVehicle] = useState("");
    const [selectedVehicleId, setSelectedVehicleId] = useState("");


    const handleVehicletypeChange = async (selectedOption) => {
        setSelectedvehicletype(selectedOption);

        try {
            const response = await fetchData('VehicleTypeApi', `/${companyId}/${selectedOption.value}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(vehicle => ({
                    value: vehicle.id,
                    label: vehicle.vehicleNo
                }));
                setVehicleOptions(options);
            }
        } catch (error) {
            console.error('Error fetching vehicle options:', error);
        }
    };

    const handleVehicleChange = async (selectedOption) => {
        setSelectedVehicle(selectedOption);
        setSelectedVehicleId(selectedOption.value);
    };

    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");


    const getCurrentDate = () => {
        const today = new Date();
        return `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
    };

    const handleRefreshClick = () => {

        // setToDate(getCurrentDate());
        // fetchData();
        window.location.reload();
    };

    const handleToDateChange = (event) => {
        const selectedDate = event.target.value;
        setToDate(selectedDate);

    }

    const [Corderdate, setCorderdate] = useState("");
    const [orderTakenby, setOrdertakenby] = useState("");

    const [filteredData, setFilteredData] = useState([]);


    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const searchfilteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );


    // Define filteredDataItem within the component
    const filteredDataItem = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const closeModal = () => {
        setShowModal(false);
    };

    //search
    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write('<html><head><title>Despatch Summary(For Loading)</title></head><body>');
        printWindow.document.write('<h3 style="font-family: Times New Roman; font-size: 32px;">Despatch Summary(For Loading)</h3>');

        // Print route, order taken by, salesman, and order date above the table
        // Print route, order taken by, salesman, and order date in the same row
        if (data.length > 0) {
            const firstRow = data[0]; // Use the first row for common details
            printWindow.document.write('<div style="margin-bottom: 20px;">');
            printWindow.document.write(`<p style="font-size: 18px;">`);
            printWindow.document.write(`<strong>Route:</strong> ${firstRow.routeName || ''} &nbsp; | &nbsp; `);
            printWindow.document.write(`<strong>Order Taken by:</strong> ${firstRow.orderTakenby || ''} &nbsp; | &nbsp; `);
            printWindow.document.write(`<strong>Sales Executive:</strong> ${firstRow.executive || ''} &nbsp; | &nbsp; `);
            printWindow.document.write(`<strong>Order Date:</strong> ${firstRow.orderDate ? new Date(firstRow.orderDate).toLocaleDateString('en-GB') : ''} &nbsp; | &nbsp; `);
            printWindow.document.write(`<strong>Vehicle No.:</strong> ${firstRow.VehicleNo || ''} &nbsp; | &nbsp; `);
            printWindow.document.write(`<strong>Driver :</strong> ${firstRow.DriverName || ''} &nbsp; | &nbsp; `);
            printWindow.document.write(`<strong>Trip Date:</strong> ${firstRow.TripDate ? new Date(firstRow.TripDate).toLocaleDateString('en-GB') : ''}`);
            printWindow.document.write(`</p>`);
            printWindow.document.write('</div>');
        }


        // Now print the table header and body
        printWindow.document.write('<table style="border-collapse: collapse; width: 100%;">');
        printWindow.document.write('<thead style="background-color: #f3f3f3;">');
        printWindow.document.write('<tr>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Sl.No</th>');

        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Product Category</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Category(Variant)</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Item Code</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Item</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">UOM (Kgs)</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Bundle</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Pieces</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Quantity(pcs)</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Total Quantity(kgs)</th>');
        // printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Active Customers</th>');
        // printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Sale Remarks</th>');
        printWindow.document.write('</tr>');
        printWindow.document.write('</thead>');
        printWindow.document.write('<tbody>');

        // Loop through data to generate rows with conditional logic
        let previousValues = {
            ordertypeName: '',
            productCategory: '',
            Category: '',
            customerid: '',
            saleremarks: ''
        };

        data.forEach((rowData, index) => {
            printWindow.document.write('<tr>');
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${index + 1}</td>`); // Sl.No
            // printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.ordertypeName !== previousValues.ordertypeName ? rowData.ordertypeName : ''}</td>`); // Order Type
            if (rowData.productCategory) {
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.productCategory !== previousValues.productCategory ? rowData.productCategory : ''}</td>`); // Product Category
            } else {
                printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;"></td>');
            }
            if (rowData.Category) {
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.Category !== previousValues.Category ? rowData.Category : ''}</td>`); // Category
            } else {
                printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;"></td>');
            }


            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.itemCode || ''}</td>`); // Item Code
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.item || ''}</td>`); // Item
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.kilogram || ''}</td>`); // UOM (Kgs)
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.Bundle || ''}</td>`); // Bundle
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.Pieces || ''}</td>`); // Pieces
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.quantity || ''}</td>`); // Quantity
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.totalkilogram || ''}</td>`); // Total Quantity



            printWindow.document.write('</tr>');

            // Update previous values for the next iteration
            previousValues = {
                ordertypeName: rowData.ordertypeName,
                productCategory: rowData.productCategory,
                Category: rowData.Category,
                //customerid: rowData.customerid,
                // saleremarks: rowData.saleremarks
            };
        });

        printWindow.document.write('</tbody></table></body></html>');
        printWindow.document.close();
        printWindow.print();
    };

    const handleExportExcel = () => {
        const excelData = [];

        // Add route, order taken by, order date, and executive as a separate header row
        const topRow = [
            `Route: ${data[0].routeName}`, // Assuming RouteName is the same for all entries
            `Order Date: ${data[0].orderDate}`, // Assuming the same OrderDate for all entries
            `Order Taken by: ${data[0].orderTakenby}`, // Assuming the same person took all orders
            `Sales Executive: ${data[0].executive}`, // Assuming the same Sales Executive for all entries
            `Trip Date: ${data[0].TripDate}`,
            `Vehicle No.: ${data[0].VehicleNo}`,
            `Driver : ${data[0].DriverName}`,
        ];

        // Push this information to the first row
        excelData.push(topRow);

        // Add an empty row to separate this information from the rest of the table
        excelData.push([]);

        // Add header row for table data
        const headerRow = [
            'Sl.No', 'Product Category', 'Category(Variant)', 'Item Code', 'Item', 'UOM (Kgs)', 'Bundle', 'Pieces', 'Quantity(pcs)', 'Total Quantity(kgs)' //'Active Customers', 'Sale Remarks'
        ];
        excelData.push(headerRow);

        // Add data rows with conditional display logic
        let previousValues = {
            ordertypeName: '',
            productCategory: '',
            Category: '',
            // customerid: '',
            // saleremarks: ''
        };

        data.forEach((rowData, index) => {
            const dataRow = [
                index + 1, // Sl.No
                // rowData.ordertypeName !== previousValues.ordertypeName ? rowData.ordertypeName : '', // Order Type
                rowData.productCategory !== previousValues.productCategory ? rowData.productCategory : '', // Product Category
                rowData.Category !== previousValues.Category ? rowData.Category : '', // Category
                rowData.itemCode, // Item Code
                rowData.item, // Item
                rowData.kilogram, // UOM (Kgs)
                rowData.Bundle, // Bundle
                rowData.Pieces, // Pieces
                rowData.quantity, // Quantity
                rowData.totalkilogram, // Total Quantity
                // rowData.customerid !== previousValues.customerid ? rowData.customerid : '', // Active Customers
                // rowData.saleremarks !== previousValues.saleremarks ? rowData.saleremarks : '' // Sale Remarks
            ];

            // Push the dataRow to excelData
            excelData.push(dataRow);

            // Update previous values for the next iteration
            previousValues = {
                OrderTypeName: rowData.ordertypeName,
                ProductCategory: rowData.productCategory,
                Category: rowData.Category,
                // CustomerId: rowData.customerid,
                // SaleRemarks: rowData.saleremarks
            };
        });

        // Create worksheet
        const ws = XLSX.utils.aoa_to_sheet(excelData);

        // Create workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Despatch Report(For Loading)');

        // Save workbook to a file
        XLSX.writeFile(wb, 'Despatch(For Loading).xlsx');
    };

    const getRowColor = (balanceQty, weight) => {
        if (balanceQty <= weight / 2) {
            return { backgroundColor: '#FFD0D0' };
        }
        else if (balanceQty <= weight / 3) {
            return { backgroundColor: '#FFFFE0' };
        }
        else {
            return {}; // Default style
        }
    };

    const handlevehicleUpdate = event => {
        event.preventDefault();

        const formData = {
            Id: TripId,
            VehicleId: selectedVehicle.value,
            SalesManId: selectedSalesMan.value,
            DriverId: selectedDriver.value,
            StartAudometereReading: startAutometereReading || selectedItem.startAudometereReading || null,
            ModifiedBy: userId,
            ModifiedDate: new Date().toISOString(),
            CompanyId: companyId,
            RouteId: routeId,
        }

        updateData('VehicleTypeApi', `${TripId}`, formData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                window.location.reload();
            })
            .catch((error) => {
                console.error('Error updating record:', error);
                setIsLoading(false);
            });
    };

    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(150); // Rows per page

    // Define initial column order
    const [columnOrder, setColumnOrder] = useState([
        'SL No',
        '',
        'PDT Category',
        'Category(Variant)',
        'Code',
        'Item',
        'UOM(kgs)',
        'Bundle',
        'Pieces',
        'Quantity(No.Pieces)',
        'Total Quantity(kgs)'

    ]);

    // Process and paginate the data
    const processedData = searchfilteredData.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );


    // Handle page change
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    // Handle rows per page change
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page
    };

    // Function to handle drag start
    const handleDragStart = (e, index) => {
        e.dataTransfer.setData('columnIndex', index);
    };

    // Function to handle drag over
    const handleDragOver = (e) => {
        e.preventDefault(); // Allow drop
    };

    // Function to handle drop
    const handleDrop = (e, index) => {
        const draggedIndex = e.dataTransfer.getData('columnIndex');
        if (draggedIndex !== index) {
            const newOrder = [...columnOrder];
            // Swap columns
            [newOrder[draggedIndex], newOrder[index]] = [newOrder[index], newOrder[draggedIndex]];
            setColumnOrder(newOrder);
        }
    };

    //Driver

    const [driverOptions, setDriverOptions] = useState([]);
    const [selectedDriver, setSelectedDriver] = useState("");

    const fetchDriver = async () => {
        try {
            // const response = await fetchData('StaffSelectionApi', `/${companyId}`, token);
            const response = await fetchData('DriverstaffApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(product => ({
                    value: product.id,
                    label: product.firstName
                }));
                setDriverOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleDriverChange = (selectedOption) => {
        setSelectedDriver(selectedOption);
    };

    useEffect(() => {
        fetchDriver();
    }, []);

    //SalesMan

    const [selectedProduct, setSelectedProduct] = useState("");
    const [salesManOptions, setSalesManOptions] = useState([]);
    const [selectedSalesMan, setSelectedSalesMan] = useState("");

    const fetchSalesMan = async () => {
        try {
            // const response = await fetchData('executiveApi', `/${companyId}`, token);

            const response = await fetchData('executiveApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(product => ({
                    value: product.id,
                    label: product.firstName
                }));
                setSalesManOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleSalesManChange = (selectedOption) => {
        setSelectedSalesMan(selectedOption);
    };

    useEffect(() => {
        fetchSalesMan();
    }, []);

    return (

        <div className="w-full  mt-6 mx-auto custom-scrollbar" style={{ width: '95%', }}>
            <style>
                {`
                    .custom-scrollbar::-webkit-scrollbar {
                        width: 3px;
                    }

                    .custom-scrollbar::-webkit-scrollbar-thumb {
                        background-color: #333;
                        border: 2px solid #555;
                        border-radius: 6px;
                    }

                    .custom-scrollbar::-webkit-scrollbar-track {
                        background-color: #ddd;
                        border-radius: 6px;
                    }
                    `}
            </style>

            <div className="w-full  mx-auto" style={{ marginTop: '-10px' }}>

                <h6
                    className="uppercase tracking-wide text-black flex-grow linkcolor"
                    style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}
                >
                    DESPATCH DETAILS- Loading
                </h6>
            </div>
            <div className="flex mb-2" style={{ marginTop: '-20px', marginLeft: '20%' }}>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1 }}>
                    Route: <strong style={{ color: 'darkblue' }}>{route}</strong>
                </h5>

                <h5
                    className="text-black"
                    style={{ fontSize: '14px', flexGrow: 1 }}
                    onClick={openModal} // Correctly placed here
                >
                    VehicleNo: <strong style={{ color: 'darkblue' }}>{VehicleNo}</strong>
                </h5>

                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1 }}>
                    Driver Name: <strong style={{ color: 'darkblue' }}>{DriverName}</strong>
                </h5>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%' }}>
                    Order Taken Date: <strong style={{ color: 'darkred' }}>{Corderdate && new Date(Corderdate).toLocaleDateString('en-GB')}</strong>
                </h5>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%' }}>
                    Order Taken By: <strong style={{ color: 'darkmagenta' }}>{orderTakenby}</strong>
                </h5>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%' }}>
                    SalesMan: <strong style={{ color: 'darkmagenta' }}>{salesman}</strong>
                </h5>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%' }}>
                    Trip Date: <strong style={{ color: 'darkred' }}>{TripDate && new Date(TripDate).toLocaleDateString('en-GB')}</strong>
                </h5>
            </div>
            <div className="flex justify-end">
                <div style={{ marginRight: '10px' }}>
                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '300px' : '200px',
                            height: '40px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                            marginTop: '-10px'
                        }}
                    />
                </div>


                <div className="w-1/4 mr-2" style={{ marginTop: '-10px', marginLeft: '2px' }}>
                    <Select
                        value={selectedTrip}
                        onChange={handleTripChange}
                        options={tripOptions}
                        placeholder="Select Trip"
                        isSearchable
                        styles={{
                            menu: (provided) => ({
                                ...provided,
                                zIndex: 1301, // Set a high z-index to ensure it appears above the sticky header
                            }),
                        }}
                    />
                </div>
                <Button
                    style={{
                        backgroundColor: '#C9E9D2',
                        color: 'black',
                        height: '36px',
                        marginTop: '-10px',
                        marginLeft: '5px'

                    }}
                    onClick={handleRefreshClick}
                    className="linkcolor"
                >
                    <span>Refresh</span>
                </Button>
                <Button
                    style={{
                        backgroundColor: '#F8E8EE',
                        color: 'black',
                        height: '36px',
                        marginTop: '-10px',
                         marginLeft: '5px'

                    }}
                    onClick={handleExportExcel}
                    className="linkcolor"
                >
                    <span>Excel</span>
                </Button>

                <Button
                    style={{
                        backgroundColor: '#E8F3D6',
                        color: 'black',
                        height: '36px',
                        marginTop: '-10px',
                        marginLeft: '5px'

                    }}
                    onClick={handlePrint}
                    className="linkcolor"
                >
                    <span>Print</span>
                </Button>


            </div>

            <div className="mt-6">
                {loading ? (
                    <CircularProgress />
                ) : (
                    <React.Fragment>

                        <div className='w-full mb-5 flex' style={{ maxHeight: '540px', overflowY: 'auto', marginTop: '-0.90%' }}>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead sx={{ backgroundColor: 'whitesmoke', width: '2500px' }}>
                                        <TableRow>
                                            {columnOrder.map((col, index) => (
                                                <TableCell
                                                    key={col || index} // Fallback for empty column name
                                                    style={{
                                                        padding: '3px',
                                                        cursor: 'grab',
                                                        color: '#1D267D',
                                                        fontWeight: 'bold',
                                                        fontSize: '12px',
                                                        textTransform: 'uppercase',
                                                        textAlign: [
                                                            'UOM(kgs)',
                                                            'Bundle',
                                                            'Pieces',
                                                            'Quantity(No.Pieces)',
                                                            'Total Quantity(kgs)'
                                                        ].includes(col) ? 'right' : 'left',
                                                    }}
                                                    draggable
                                                    onDragStart={(e) => handleDragStart(e, index)}
                                                    onDragOver={(e) => {
                                                        e.preventDefault();
                                                        handleDragOver(e);
                                                    }}
                                                    onDrop={(e) => handleDrop(e, index)}
                                                >
                                                    {col || '-'} {/* Handles empty column name */}
                                                </TableCell>
                                            ))}
                                        </TableRow>

                                    </TableHead>

                                    <TableBody>
                                        {Array.isArray(processedData) && processedData.length > 0 ? (
                                            processedData.map((rowData, index) => {
                                                const showOrderTypeName =
                                                    index === 0 || rowData.OrderTypeName !== searchfilteredData[index - 1]?.OrderTypeName;
                                                const showProductCategory =
                                                    index === 0 || rowData.productCategory !== searchfilteredData[index - 1]?.productCategory;
                                                const showCategory =
                                                    index === 0 || rowData.Category !== searchfilteredData[index - 1]?.Category;

                                                const rowValues = {
                                                    'SL No': index + 1,
                                                    'Order Type': showOrderTypeName ? rowData.OrderTypeName || '' : '',
                                                    'Product Category': showProductCategory ? rowData.productCategory || '' : '',
                                                    Category: showCategory ? rowData.Category || '' : '',
                                                    'Item Code': rowData.itemCode || '',
                                                    Item: rowData.item || '',
                                                    Kilogram: rowData.kilogram || '',
                                                    Bundle: rowData.Bundle || '',
                                                    Pieces: rowData.Pieces || '',
                                                    Quantity: rowData.quantity || '',
                                                    'Total Kilogram': rowData.totalkilogram || '',

                                                };

                                                const isHighlightedRow =
                                                    rowData.OrderTypeName?.includes('Total') || rowData.ProductCategory === 'GRAND Total';

                                                return (
                                                    <React.Fragment key={index}>
                                                        {/* Main Row */}
                                                        <TableRow
                                                            style={{
                                                                backgroundColor: isHighlightedRow ? '#F5EFE3' : 'inherit',
                                                            }}
                                                        >
                                                            {Object.keys(rowValues).map((key) => (
                                                                <TableCell
                                                                    key={key}
                                                                    sx={{
                                                                        fontSize: '13px',
                                                                        padding: '4px',
                                                                        //textAlign: 'left',
                                                                        textAlign: ['Kilogram', 'Bundle', 'Pieces', 'Quantity', 'Total Kilogram'].includes(key) ? 'right' : 'left',
                                                                        width: '20px',
                                                                    }}
                                                                >
                                                                    {rowValues[key]}
                                                                </TableCell>
                                                            ))}
                                                        </TableRow>


                                                    </React.Fragment>
                                                );
                                            })
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={12} sx={{ textAlign: 'center' }}>
                                                    No data available.
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                    {/* Render Grand Total in Footer */}
                                    <TableFooter style={{ padding: '5px' }}>
                                        <TableRow>
                                            <TablePagination
                                                rowsPerPageOptions={[15, 25, 50, 100, 150, 250, 350, 500]}
                                                count={searchfilteredData.length}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                onPageChange={handlePageChange}
                                                onRowsPerPageChange={handleRowsPerPageChange}

                                            />
                                        </TableRow>


                                    </TableFooter>

                                </Table>
                            </TableContainer>
                        </div>
                    </React.Fragment>
                )}
            </div>

            <Modal open={showModal} className={showModal ? 'notification-modal' : ''}>

                <div className="fixed inset-0 flex items-center justify-center z-10">
                    <div
                        className="bg-green-100 p-6 rounded-lg shadow-lg w-11/12 md:w-1/2"
                        style={{ height: '50%' }}
                    >
                        {/* Header with Action Buttons */}
                        <div className="flex justify-end space-x-2 mb-4">
                            <Button
                                onClick={handlevehicleUpdate}
                                className="close-button bg-white"
                                style={{ marginTop: '-20px' }}
                            >
                                <Tooltip title="Update Vehicle">
                                    <span className="flex items-center text-green-600">
                                        <FaCar className="mr-1" /> Update
                                    </span>
                                </Tooltip>
                            </Button>
                            <Button
                                onClick={closeModal}
                                className="close-button bg-white"
                                style={{ marginTop: '-20px', marginLeft: '5px' }}
                            >
                                <Tooltip title="Close">
                                    <span className="flex items-center text-red-600">
                                        <FaTimes className="mr-1" /> Close
                                    </span>
                                </Tooltip>
                            </Button>
                        </div>

                        {/* Modal Title */}
                        <h6 className="text-center text-darkblue mb-6">
                            NEED TO CHANGE VEHICLE?
                        </h6>

                        {/* Vehicle Selection Section */}
                        <div className="flex space-x-4">
                            {/* Vehicle Model Select */}
                            <div className="w-1/2 mr-2">
                                <label
                                    htmlFor="vehicleModel"
                                    className="block text-black text-sm mb-2"
                                >
                                    Vehicle Model
                                </label>
                                <Select
                                    id="vehicleModel"
                                    value={selectedvehicletype}
                                    onChange={handleVehicletypeChange}
                                    options={vehicletypeOptions}
                                    placeholder="Vehicle Model"
                                    isSearchable
                                />
                            </div>

                            {/* Vehicle No. Select */}
                            <div className="w-1/2 mr-2">
                                <label
                                    htmlFor="vehicleNo"
                                    className="block text-black text-sm mb-2"
                                >
                                    Vehicle No.
                                </label>
                                <Select
                                    id="vehicleNo"
                                    value={selectedVehicle}
                                    onChange={handleVehicleChange}
                                    options={vehicleOptions}
                                    placeholder="Select Vehicle"
                                    isSearchable
                                />
                            </div>
                        </div>
                        <div className="flex space-x-4">

                            <div className="w-1/2 mr-2">
                                <label
                                    htmlFor="SalesMan"
                                    className="block text-black text-sm mb-2"
                                >
                                    SalesMan
                                </label>
                                <Select
                                    value={selectedSalesMan}
                                    onChange={handleSalesManChange}
                                    options={salesManOptions}
                                    placeholder="SalesMan"
                                    isSearchable
                                />
                            </div>
                            <div className="w-1/2 mr-2">
                                <label
                                    htmlFor="Driver"
                                    className="block text-black text-sm mb-2"
                                >
                                    Driver
                                </label>
                                <Select
                                    value={selectedDriver}
                                    onChange={handleDriverChange}
                                    options={driverOptions}
                                    placeholder="Driver"
                                    isSearchable
                                />
                            </div>
                            <div className="w-1/2 mr-2">
                                <label
                                    htmlFor="startAutometereReading"
                                    className="block text-black text-sm mb-2"
                                >
                                    Start Odometer
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={startAutometereReading}
                                    onChange={(e) => setStartAutometereReading(e.target.value)}
                                    type="text"
                                    placeholder="Enter Start Odometer"
                                />
                            </div>
                        </div>
                    </div>
                </div>

            </Modal>
        </div>



    );
};
export default ForLoadingDespatchReport;
